<template>
  <base-modal
    :ref="modal.key"
    :show="open"
    :title="modalTitle"
    :subtitle="accessRight.name"
    @on-confirm="saveItem"
    @on-cancel="hide()"
    :okText="$t('Save')"
    :closeText="$t('Close')"
    maxWidth="70%"
  >
    <v-text-field
      v-bind:label="$t('Name')"
      v-model="accessRight.name"
      :error-messages="nameErrors"
      @input="$v.accessRight.name.$touch()"
      @blur="$v.accessRight.name.$touch()"
    ></v-text-field>
    <v-row>
      <v-col cols="12" md="5">
        <v-card class="mb-2" height="100%">
          <v-card-subtitle>{{ $t("Documents") }}</v-card-subtitle>
          <v-card-text class="pb-0 pt-0">
            <v-row>
              <v-col>
                <v-row align="center" class="mx-2">
                  <p>{{ $t("Create") }}</p>
                  <v-spacer></v-spacer>
                  <v-switch v-model="accessRight.objectCreate" />
                </v-row>
                <v-row align="center" class="mx-2">
                  <p>{{ $t("Read") }}</p>
                  <v-spacer></v-spacer>
                  <v-switch v-model="accessRight.objectRead" />
                </v-row>
                <v-row align="center" class="mx-2">
                  <p>{{ $t("Edit") }}</p>
                  <v-spacer></v-spacer>
                  <v-switch v-model="accessRight.objectUpdate" />
                </v-row>
                <v-row align="center" class="mx-2">
                  <p>{{ $t("Delete") }}</p>
                  <v-spacer></v-spacer>
                  <v-switch v-model="accessRight.objectDelete" />
                </v-row>
              </v-col>
              <v-col>
                <v-row align="center" class="mx-2">
                  <p>{{ $t("Download") }}</p>
                  <v-spacer></v-spacer>
                  <v-switch v-model="accessRight.objectDownload" />
                </v-row>
                <v-row align="center" class="mx-2">
                  <p>{{ $t("Print") }}</p>
                  <v-spacer></v-spacer>
                  <v-switch v-model="accessRight.objectPrint" />
                </v-row>
                <v-row align="center" class="mx-2">
                  <p>{{ $t("Sign") }}</p>
                  <v-spacer></v-spacer>
                  <v-switch v-model="accessRight.objectSign" />
                </v-row>
                <v-row align="center" class="mx-2">
                  <p>{{ $t("DistributeExternal") }}</p>
                  <v-spacer></v-spacer>
                  <v-switch v-model="accessRight.objectExternalDistribution" />
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" md="3">
        <v-card class="mb-2" height="100%">
          <v-card-subtitle>{{ $t("DocumentAttachments") }}</v-card-subtitle>
          <v-card-text class="pb-0 pt-0">
            <v-row align="center" class="mx-2">
              <p>{{ $t("Create") }}</p>
              <v-spacer></v-spacer>
              <v-switch
                color="green"
                v-model="accessRight.documentAttachmentCreate"
              />
            </v-row>
            <v-row align="center" class="mx-2">
              <p>{{ $t("Read") }}</p>
              <v-spacer></v-spacer>
              <v-switch
                color="green"
                v-model="accessRight.documentAttachmentRead"
              />
            </v-row>
            <v-row align="center" class="mx-2">
              <p>{{ $t("Edit") }}</p>
              <v-spacer></v-spacer>
              <v-switch
                color="green"
                v-model="accessRight.documentAttachmentUpdate"
              />
            </v-row>
            <v-row align="center" class="mx-2">
              <p>{{ $t("Delete") }}</p>
              <v-spacer></v-spacer>
              <v-switch
                color="green"
                v-model="accessRight.documentAttachmentDelete"
              />
            </v-row>
            <v-row align="center" class="mx-2">
              <p>{{ $t("Download") }}</p>
              <v-spacer></v-spacer>
              <v-switch
                color="green"
                v-model="accessRight.documentAttachmentDownload"
              />
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="mb-2" height="58%">
          <v-card-subtitle>{{ $t("Comments") }}</v-card-subtitle>
          <v-card-text class="pb-0 pt-0">
            <v-row>
              <v-col>
                <v-row align="center" class="mx-2">
                  <p>{{ $t("Create") }}</p>
                  <v-spacer></v-spacer>
                  <v-switch
                    color="orange"
                    v-model="accessRight.commentCreate"
                  />
                </v-row>
                <v-row align="center" class="mx-2">
                  <p>{{ $t("Delete") }}</p>
                  <v-spacer></v-spacer>
                  <v-switch
                    color="orange"
                    v-model="accessRight.commentDelete"
                  />
                </v-row>
              </v-col>
              <v-col>
                <v-row align="center" class="mx-2">
                  <p>{{ $t("Edit") }}</p>
                  <v-spacer></v-spacer>
                  <v-switch
                    color="orange"
                    v-model="accessRight.commentUpdate"
                  />
                </v-row>
                <v-row align="center" class="mx-2">
                  <p>{{ $t("Read") }}</p>
                  <v-spacer></v-spacer>
                  <v-switch color="orange" v-model="accessRight.commentRead" />
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card class="mb-2" height="40%">
          <v-card-subtitle>{{ $t("InternalTables") }}</v-card-subtitle>
          <v-card-text class="pb-0 pt-0">
            <v-row align="center" class="mx-2">
              <p>{{ $t("InsertData") }}</p>
              <v-spacer></v-spacer>
              <v-switch
                color="purple"
                v-model="accessRight.dynamicTablesAddData"
              />
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <template slot="footer">
      <v-switch
        class="ml-4"
        color="primary"
        v-model="selection"
        @change="selectAll"
        :label="$t('SelectAll')"
      />
    </template>
  </base-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";

import AccessRightService from "@/services/AccessRightService";
import AccessRight from "@/ecm/models/AccessRight";
import Utils from "@/ecm/common/Utils";

export default {
  name: "AccessRightModal",
  created() {
    this.$v.$reset();
  },
  data() {
    return {
      modal: {
        title: this.$t("AccessRight"),
        key: "accessRightModal",
      },
      open: false,
      selection: false,
      accessRight: new AccessRight(),
      isNew: true,
    };
  },
  mixins: [validationMixin],
  validations: {
    accessRight: {
      name: { required },
    },
  },
  computed: {
    modalInstance() {
      return this.$refs[this.modal.key];
    },
    modalTitle() {
      return (
        this.modal.title +
        (this.accessRight.name ? " - " + this.accessRight.name : "")
      );
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.accessRight.name.$dirty) return errors;
      !this.$v.accessRight.name.required &&
        errors.push(this.$t("RequiredField"));
      return errors;
    },
  },
  methods: {
    selectAll() {
      this.accessRight.objectCreate = this.selection;
      this.accessRight.objectRead = this.selection;
      this.accessRight.objectUpdate = this.selection;
      this.accessRight.objectDelete = this.selection;
      this.accessRight.objectDownload = this.selection;
      this.accessRight.objectPrint = this.selection;
      this.accessRight.objectSign = this.selection;
      this.accessRight.objectExternalDistribution = this.selection;
      this.accessRight.documentAttachmentCreate = this.selection;
      this.accessRight.documentAttachmentDelete = this.selection;
      this.accessRight.documentAttachmentRead = this.selection;
      this.accessRight.documentAttachmentUpdate = this.selection;
      this.accessRight.documentAttachmentDownload = this.selection;
      this.accessRight.commentCreate = this.selection;
      this.accessRight.commentRead = this.selection;
      this.accessRight.commentUpdate = this.selection;
      this.accessRight.commentDelete = this.selection;
      this.accessRight.dynamicTablesAddData = this.selection;
    },
    saveItem() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.modalInstance.progress(true);

      AccessRightService.save(this.accessRight.toDto())
        .then((result) => {
          if (this.isNew) {
            Utils.toast.success(
              this.$t("AccessRight") + " " + this.$t("CreatedSuccessfully")
            );
          } else {
            Utils.toast.success(
              this.$t("AccessRight") + " " + this.$t("UpdatedSuccessfully")
            );
          }
          this.hide();
          this.$emit("on-item-saved");
        })
        .catch((error) => {
          // error
        })
        .then(() => {
          //always
          this.modalInstance.progress(false);
        });
    },
    new() {
      this.accessRight = new AccessRight();
      this.$v.$reset();
      this.selection = false;
      this.show();
    },
    edit(dto) {
      this.accessRight = new AccessRight(dto);
      this.isNew = false;
      this.selection = false;
      this.show();
    },
    show() {
      this.open = true;
    },
    hide() {
      this.open = false;
      this.isNew = true;
    },
  },
};
</script>
